import {
  type ClientApplicationContext,
  getClientApplicationContext,
} from '@hc-frontend/core-context';

import type { AuthenticationHook } from '../../hooks/use-authentication/use-authentication.types';

export function getMemberIdClientSide(
  session: AuthenticationHook,
): ClientApplicationContext['getMemberId'] {
  return async () => {
    const context = getClientApplicationContext(getMemberIdClientSide);

    if (session.status === 'authenticated') {
      return session.user.id;
    }

    context.log({
      context: 'client',
      message: 'noUserFound',
      type: 'error',
    });

    return '';
  };
}
